import { render, staticRenderFns } from "./OrderDisputed.vue?vue&type=template&id=1dc39399&"
import script from "./OrderDisputed.vue?vue&type=script&lang=js&"
export * from "./OrderDisputed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports